import { get, post, unwrapPage } from "./api_helper";

const mapContact = (c) => ({
  ...c,
  name: c.fullName || [c.firstName, c.lastName].filter(Boolean).join(" "),
});

// GET /api/contacts/lists?page=&size=&search= → Page<ContactListResponse>.
export const getContactListData = ({ page = 0, pageSize = 20, search = "" } = {}) => {
  const params = new URLSearchParams({ page, size: pageSize });
  if (search) params.set("search", search);
  return get(`contacts/lists?${params.toString()}`).then((res) => {
    const p = unwrapPage(res);
    const rows = p.rows.map((l) => ({
      ...l,
      numberOfContacts: l.contactCount,
      created_at: l.createdOn,
    }));
    return { rows, total: p.total, totalPages: p.pages };
  });
};

// GET /api/contacts?page=&size= → Page<ContactResponse> (all tenant contacts).
export const getContactsData = ({ page = 0, pageSize = 20 } = {}) =>
  get(`contacts?page=${page}&size=${pageSize}&sortBy=id&sortDirection=DESC`).then((res) => {
    const p = unwrapPage(res);
    return { rows: p.rows.map(mapContact), total: p.total, totalPages: p.pages };
  });

// POST /api/contacts/search → Page<ContactResponse>. Keyword across name/mobile/email.
export const searchContactsData = ({ keyword, page = 0, pageSize = 20 }) =>
  post("contacts/search", { keyword, page, size: pageSize, sortBy: "id", sortDirection: "DESC" }).then((res) => {
    const p = unwrapPage(res);
    return { rows: p.rows.map(mapContact), total: p.total, totalPages: p.pages };
  });

// GET /api/contacts/{id} → ContactResponse.
export const getContactById = (id) => get(`contacts/${id}`).then(mapContact);

// POST /api/contacts → create a single contact.
export const createContact = (dto) =>
  post("contacts", {
    firstName: dto.firstName,
    lastName: dto.lastName || undefined,
    mobile: dto.mobile,
    email: dto.email || undefined,
    contactType: dto.contactType || undefined,
  });

// GET /api/contacts/summary → ContactSummaryResponse (totalContacts, activeContacts, favoriteContacts, ...).
export const getContactSummary = () => get("contacts/summary");

// GET /api/contacts/lists/{listId}/contacts?search=&page=&size= → Page<ContactResponse>.
// Server-side paginated + searchable; normalized to the legacy snake_case shape.
// Accepts {id, search, page, pageSize} (or a bare id for back-compat).
export const getContactListDetailData = (payload) => {
  const { id, search = "", page = 0, pageSize = 20 } =
    payload && typeof payload === "object" ? payload : { id: payload };
  const params = new URLSearchParams({ page, size: pageSize });
  if (search) params.set("search", search);
  return get(`contacts/lists/${id}/contacts?${params.toString()}`).then((res) => {
    const p = unwrapPage(res);
    const rows = p.rows.map((c) => ({
      ...c,
      id: c.id,
      first_name: c.firstName,
      last_name: c.lastName,
      msisdn: c.mobile,
      email: c.email,
      expiry_date: c.expiryDate,
      county: c.county,
    }));
    return { rows, total: p.total, totalPages: p.pages };
  });
};
